import Image from 'next/image';
import styles from './RaceTeamPictures.module.scss';

const RaceTeamPictures = () => {
  return (
    <section className="container">
      <div className={styles.raceTeamPictures}>
        <Image
          src="/img/race-team/race-picture1.webp"
          alt="Race Team"
          width={387}
          height={260}
          className={styles.raceTeamPicture}
        />
        <Image
          src="/img/race-team/race-picture2.webp"
          alt="Race Team"
          width={387}
          height={260}
          className={styles.raceTeamPicture}
        />
        <Image
          src="/img/race-team/race-picture3.webp"
          alt="Race Team"
          width={387}
          height={260}
          className={styles.raceTeamPicture}
        />
      </div>
    </section>
  );
};

export default RaceTeamPictures;
